export default {
  colors: {
    primary: '#3579f5',
    secondary: 'black',
    background: 'black'
  },
  content: {
    padding: '0 0.75em 1em',
    width: '400px'
  },
  trigger: {
    color: 'white',
    hoverColor: 'white',
    backgroundColor: 'black',
    hoverBackgroundColor: '#111',
    border: 'none',
    padding: '14px 1.25em',
    borderRadius: '6px',
    fontSize: '14px'
  },
  input: {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    padding: '1em',
    color: 'white',
    fontSize: '14px',
    borderRadius: '4px',
    border: 'none'
  },
  label: {
    fontSize: '12px'
  },
  tab: {
    color: 'rgba(255, 255, 255, 0.8)',
    border: 'none',
    borderRadius: '4px',
    padding: '1em',
    backgroundColor: 'rgba(255, 255, 255, 0.15)'
  },
  uploadButton: {
    color: 'white',
    hoverColor: 'white',
    border: 'none',
    hoverBorder: 'none',
    backgroundColor: '#222',
    hoverBackgroundColor: '#323232'
  },
  image: {
    border: 'none'
  }
}
